import React, {useEffect} from 'react'
import { IconButton, Popover, Typography, Grid, TextField} from '@material-ui/core';
import '../App.css';
import { FiHelpCircle } from "react-icons/fi";
import { Transition } from 'react-transition-group';
import { useStyles } from '../Components/useStyles';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
  import DateFnsUtils from '@date-io/date-fns';
  import 'date-fns';
 
export default function NewSiblingInformationPage({setSiblingPupliNo, siblingStudentID, showSibIPage, firstTimeInSibPage, setSiblingFirstName,
    setSiblingLastName, setSiblingDOB, siblingFirstName, siblingLastName, siblingDOB, setIsInvalidDOB, appliedProgram}) {
    const classes = useStyles();

    const [errorFirstNameState, setErrorFirstNameState] = React.useState(false);
    const [errorLastNameState, setErrorLastNameState] = React.useState(false);
    const [requiredInput, setRequiredInput] = React.useState(false);

    const regexpName = /^$|^[-A-Za-z ]+$/;


    let firstName = siblingFirstName;
    let lastName = siblingLastName;

    useEffect(() => {
        requiredCheck();
     },[siblingFirstName, siblingLastName, siblingDOB]);

    useEffect(() =>{
        setIsInvalidDOB(false);
     },[]);

    function handleDateChange(date) {
        if(date !== null && !isNaN(date.getTime()))
            setSiblingDOB(date.toDateString());
        else if(date === null)
            setSiblingDOB(null);
    }
    function handleFirstNameBlur(firstname){
        if(firstname === '')
            setErrorFirstNameState(true);
        setSiblingFirstName(firstname);
    }
    function handleLastNameBlur(lastname){
        if(lastname === '') {
            setErrorLastNameState(true);
        }

        setSiblingLastName(lastname);
    }

    function requiredCheck() {
        if((siblingStudentID != null && siblingStudentID != '') || (siblingFirstName != null && siblingFirstName != '') || (siblingLastName != null && siblingLastName != '') || (siblingDOB != null && siblingDOB != '')) {
            setRequiredInput(true);
        } else {
            setRequiredInput(false);
        }
    }

    function validateDOB(date) {
        if((new Date(date)) == "Invalid Date" && date != "mm/dd/yyyy") {
            setIsInvalidDOB(true);
        } else {
            setIsInvalidDOB(false);
        }
    }
    
    const duration = 700;

    const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
    }

    const transitionStyles = {
    entering: { opacity: 1 },
    entered:  { opacity: 1 },
    exiting:  { opacity: 0 },
    exited:  { opacity: 0 },
    };
    return (
        <>
            <Transition in={showSibIPage} timeout={duration} appear ={firstTimeInSibPage}>
            {state => (
            <div style={{
                ...defaultStyle,
                ...transitionStyles[state]
            }}>
                <h1 className='Title2-settings'>Does the student have a sibling already attending this District Program? If not, click next.</h1>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <TextField id="txt_siblingstudentid" label="Sibling's Pupil Number" defaultValue={siblingStudentID === 0 ? '': siblingStudentID} 
                            className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onBlur={event=>setSiblingPupliNo(event.target.value)} inputProps={{maxLength: 9}}

                        /> 
                    </Grid>
                    <Grid item xs={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>           
                            <KeyboardDatePicker variant="inline" required = {requiredInput} format="MM/dd/yyyy" margin="normal" id="date_siblingDOB" label="Date of Birth" emptyLabel="mm/dd/yyyy"
                                value={siblingDOB} fullWidth={true} KeyboardButtonProps={{ 'aria-label': 'change date',}}  maxDate={new Date()} maxDateMessage={"Sibling's Birthdate can not be in the future"}
                                className={classes.FulltextField} inputVariant="outlined" disableFuture={true} onChange={handleDateChange} onBlur={event=>validateDOB(event.target.value)}
                        />
                        </MuiPickersUtilsProvider>  
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField required = {requiredInput} id="txt_siblingFirstName" label="First Name" defaultValue={siblingFirstName} error={errorFirstNameState || !regexpName.test(firstName)} helperText={errorFirstNameState ? 'Cannot leave this empty!' : !regexpName.test(firstName) ? 'Please use english letters' : ''}
                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onBlur={event=>handleFirstNameBlur(event.target.value)}
                    /> 
                </Grid>
                <Grid item xs={6}>
                    <TextField required = {requiredInput} id="txt_siblingLastName" label="Last Name" defaultValue={siblingLastName} error={errorLastNameState || !regexpName.test(lastName)} helperText={errorLastNameState ? 'Cannot leave this empty!' : !regexpName.test(lastName) ? 'Please use english letters' : ''}
                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onBlur={event=>handleLastNameBlur(event.target.value)}
                    /> 
                </Grid>
            </Grid>
            </div>)}
            </Transition>
        </>
    );
}